import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Transition as _Transition, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/McLaren-logo.svg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "navbar-brand-container d-lg-none" }
const _hoisted_7 = ["href", "onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  width: "300",
  height: "77",
  class: "img-fluid",
  src: _imports_0,
  alt: "The word McLaren in white featuring a white speed mark above the 'N' and the word Applied in smaller text below."
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  class: "collapse navbar-collapse",
  id: "main-menu"
}
const _hoisted_11 = { class: "navbar-brand-container d-none d-lg-block" }
const _hoisted_12 = ["href", "onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid",
  src: _imports_0,
  alt: "The word McLaren in white featuring a white speed mark above the 'N' and the word Applied in smaller text below."
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MainMenu = _resolveComponent("MainMenu")!
  const _component_SecondaryMenu = _resolveComponent("SecondaryMenu")!

  return (_openBlock(), _createElementBlock("header", {
    onMouseleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hideSecondaryMenu && _ctx.hideSecondaryMenu(...args)))
  }, [
    _createElementVNode("nav", {
      class: _normalizeClass({'expanded': _ctx.expandMobileNav, 'navbar fixed-top navbar-expand-lg navbar-dark': true }),
      "aria-label": "Main navigation"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSecondaryMenu && _ctx.toggleSecondaryMenu(...args))),
          onMouseenter: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetSecondaryMenu && _ctx.resetSecondaryMenu(...args))),
          class: _normalizeClass({ expanded: _ctx.showSecondaryMenu, 'secondary-navbar-toggler d-none d-lg-block': true }),
          type: "button",
          "aria-controls": "secondary-menu",
          "aria-expanded": "false",
          "aria-label": "Toggle secondary menu"
        }, _hoisted_3, 34),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (this.expandMobileNav = !this.expandMobileNav)),
          ref: "menuToggler",
          class: _normalizeClass({ expanded: false, 'navbar-toggler': true, collapsed: true }),
          type: "button",
          "data-bs-toggle": "collapse",
          "data-bs-target": "#main-menu",
          "aria-controls": "main-menu",
          "aria-expanded": "false",
          "aria-label": "Toggle navigation"
        }, _hoisted_5, 512),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.menuLoaded)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: { name: 'Home'},
                custom: ""
              }, {
                default: _withCtx(({ href, navigate }) => [
                  _createElementVNode("a", {
                    class: "navbar-brand",
                    href: href,
                    onClick: navigate
                  }, _hoisted_9, 8, _hoisted_7)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_MainMenu, {
            onDisplaySecondaryMenu: _ctx.displaySecondaryMenu,
            onHideSecondaryMenu: _ctx.hideSecondaryMenu
          }, null, 8, ["onDisplaySecondaryMenu", "onHideSecondaryMenu"]),
          _createVNode(_component_SecondaryMenu, {
            showSecondaryMenu: true,
            mobile: true
          }),
          _createElementVNode("div", _hoisted_11, [
            (_ctx.menuLoaded)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: { name: 'Home'},
                  custom: ""
                }, {
                  default: _withCtx(({ href, navigate }) => [
                    _createElementVNode("a", {
                      class: "navbar-brand",
                      href: href,
                      onClick: navigate
                    }, _hoisted_14, 8, _hoisted_12)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 2),
    _createVNode(_Transition, {
      name: "slide-fade",
      id: "secondary-menu"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SecondaryMenu, {
          showSecondaryMenu: _ctx.showSecondaryMenu,
          secondaryMenu: _ctx.secondaryMenu
        }, null, 8, ["showSecondaryMenu", "secondaryMenu"])
      ]),
      _: 1
    })
  ], 32))
}